"use client"

import React from 'react';
import {Path} from "@/types/Paths";
import {Link} from "@/i18n/routing";
import styles from "./SinglePath.module.css";
import Infos from "@/components/Infos/Infos";
import FeaturedImage from "@/components/FeaturedImage/FeaturedImage";

export default function SinglePath(props: { data: Path, className?: string }) {
  const {data: {id, name}} = props
  return <Link className={props.className} href={`cammino/${id}`}>
    <div className={styles.inner}>
      <FeaturedImage width={100} height={100}
                     src={props.data?.images[0]?.url + '/100x100' || '/PLACEHOLDER-100x100px.png'}/>
      <div className={styles.infoWrapper}>
        <h3>{name}</h3>
        <Infos className={styles.infos} data={props.data}/>
      </div>
    </div>
  </Link>
}
